// extracted by mini-css-extract-plugin
export default {"spaced":"LoadingComponent_spaced__caXwC","fullWidth":"LoadingComponent_fullWidth__ZLwWC"};